export const APP_VERSION = '1.00.006';
